import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-263" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-264" data-mp="cn7riumnqbzc">
        <div className="text-center mb-16" data-id="element-265" data-mp="cm508llfa7iw">
          <p className="text-gold-dark font-bold tracking-widest uppercase text-sm mb-3" data-id="element-266" data-mp="7qhcmaml9mfi">
            What You Get: 6 Complete Resources in One Package
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-ink" data-id="element-267" data-mp="3c3mlum7utz1p">
            📚 The Complete 6-Volume Lesson Library
          </h2>
          <p className="text-xl text-forest" data-id="element-268" data-mp="3pvsw5robtbt8">
            150 complete lessons · All levels covered · Nothing to build from scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-269" data-mp="2xegjipdpzspl">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-gold shadow-[0_10px_30px_rgba(201,162,39,0.2)]' : 'border-sage shadow-sm'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-270" data-mp="2sfx1h028z12i" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-gold text-ink font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-271" data-mp="1qi7fj97c9cpu">
                  MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-272" data-mp="20d93w2tsiard">
                <span className="text-4xl" aria-hidden="true" data-id="element-273" data-mp="24gxder1zfgf9">
                  {volume.icon}
                </span>
                <div data-id="element-274" data-mp="3bsxs0xis5ftr">
                  <div className="text-gold-dark font-bold text-sm uppercase tracking-wider" data-id="element-275" data-mp="3btfyso32jcfx">
                    {volume.number} · {volume.lessons}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-ink" data-id="element-276" data-mp="1gprmas403fhq">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-ink font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-277" data-mp="1prr4vounyrms">
                {volume.subtitle}
              </p>

              <div className="mb-6" data-id="element-278" data-mp="1kqbintgr2f2t">
                <h4 className="text-sm font-bold text-charcoal uppercase tracking-wider mb-2" data-id="element-279" data-mp="x2bt2wv6cupt">
                  What does this solve for your teaching?
                </h4>
                <p className="text-charcoal text-sm leading-relaxed" data-id="element-280" data-mp="szf66tylqcg2">{volume.problem}</p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-281" data-mp="121wuddxthf5p">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-282" data-mp="ec2iozp8hwn1">
                    <CheckCircle2 size={18} className="text-forest shrink-0 mt-0.5" data-id="element-283" data-mp="ea9b9i6sr8dz" />
                    <span className="text-charcoal text-sm" data-id="element-284" data-mp="9czbb8ls7ebw">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-sage-light border border-sage rounded-xl p-4 mt-auto" data-id="element-285" data-mp="2pr2oxk3syh3k">
                <span className="text-forest font-bold block mb-1" data-id="element-286" data-mp="2bzwj769xjn88">Result:</span>
                <p className="text-ink text-sm" data-id="element-287" data-mp="2bxtjtvmw0hqu">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}